import { render, staticRenderFns } from "./BannerSupervisor.vue?vue&type=template&id=15e2469d&scoped=true&"
import script from "./BannerSupervisor.vue?vue&type=script&lang=js&"
export * from "./BannerSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./BannerSupervisor.vue?vue&type=style&index=0&id=15e2469d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2469d",
  null
  
)

export default component.exports